import Build from './components/Build';
import LoginHOC from '../../components/LoginHOC';
import ErrorBoundary from '../../components/ErrorBoundary';
import OngoingBuildGuard from './components/OngoingBuildGuard';
import { useAnalyticsCommand } from '../../utilities/useAnalytics';
import { BuildFlags } from './utilities/types';

export default function BuildCommand({
  configPath,
  flags,
}: {
  configPath?: string;
  flags: BuildFlags;
}) {
  useAnalyticsCommand('build', {
    async: flags.exitAfterUploading,
    codeSign: flags.shouldCodeSign,
    config: configPath,
    webhook: flags.onBuildFinishedWebhook,
  });

  const commandUsed = 'todesktop build';

  return (
    <ErrorBoundary>
      <LoginHOC>
        <OngoingBuildGuard configPath={configPath} commandUsed={commandUsed}>
          <Build
            commandUsed={commandUsed}
            configPath={configPath}
            flags={flags}
          />
        </OngoingBuildGuard>
      </LoginHOC>
    </ErrorBoundary>
  );
}
